import PropTypes from 'prop-types'
import { useState } from 'react'
import { TogglePane, MultiSelect, kuiperClassNames } from '@opallabs/kuiper'

const labelSetHeader = (name) => (
  <span className={kuiperClassNames('header-label')}>{name}</span>
)

export const LabelPanel = ({
  enableSaveButton,
  labelSet,
  onClear,
  onSelect,
  onRemove,
  theme,
}) => {
  const [selectedLables, setSelectedLables] = useState(labelSet.values)

  const popoverId = `label-set-${labelSet.id}`

  const onRemoveLabel = (label) => {
    const nextSelectedLabels = selectedLables.filter(
      (item) => item.id !== label.id
    )
    setSelectedLables(nextSelectedLabels)
    enableSaveButton(true)
    onRemove(label)
  }

  const onSelectLabel = (label) => {
    const nextSelectedLabels = [...selectedLables, label]
    setSelectedLables(nextSelectedLabels)
    enableSaveButton(true)
    onSelect(label)
  }

  const onClearLabels = (labelsToRemove) => {
    setSelectedLables([])
    enableSaveButton(true)
    onClear(labelsToRemove)
  }

  return (
    <TogglePane
      startOpen={
        Boolean(labelSet.values.length) ||
        labelSet.isRequired ||
        labelSet.isChild
      }
      header={labelSetHeader(labelSet.name)}
      popoverId={popoverId}
      shouldValidate={labelSet.isRequired}
      theme={theme}
      valid={labelSet.isRequired && Boolean(selectedLables.length)}
    >
      <MultiSelect
        canSelectAll={false}
        clearSearchOnSelect
        selectMatchOnEnter
        theme={theme}
        onClearAll={onClearLabels}
        onRemove={onRemoveLabel}
        onSelect={onSelectLabel}
        options={labelSet.labels}
        id={popoverId}
        value={selectedLables}
      />
    </TogglePane>
  )
}
LabelPanel.displayName = 'Photon: LabelPanel ← LabelPicker'

LabelPanel.propTypes = {
  enableSaveButton: PropTypes.func,
  labelSet: PropTypes.shape({
    id: PropTypes.string,
    isChild: PropTypes.bool,
    isRequired: PropTypes.bool,
    labels: PropTypes.array,
    name: PropTypes.string,
    values: PropTypes.array,
  }),
  onClear: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  theme: PropTypes.oneOf(['light', 'dark']),
}
